<template>
  <span class="podcast">
    <MicrophoneIcon class="podcast__icon" /> <slot />
  </span>
</template>

<script setup>
  import MicrophoneIcon from '../../svg/MicrophoneIcon.vue';
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>